import { Box, Link, Typography } from "@mui/material"
import useTranslation from "hooks/use_translation"

const Login = () => {
  const { pages } = useTranslation()

  return (
    <Box sx={{ my: 2.5, display: "flex", justifyContent: "center" }}>
      <Typography variant="body1">{pages?.registration_page?.have_an_account}</Typography>
      <Link sx={{ cursor: "pointer", textDecoration: "none", ml: 1 }} href="/login">
        <Typography variant="body1">{pages?.home?.login}</Typography>
      </Link>
    </Box>
  )
}

export default Login
